import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "sonner";

import Axios from "@/lib/axios-instance";

type APIPayload = {
    file: File | null;
};

type ResponseType = {
    data: any;
    meta: any;
};

export const addSourceFile = async (payload: APIPayload, onProgress: (progress: number) => void) => {
    try {
        const formData = new FormData();
        if (payload.file) {
            formData.append("file", payload.file);
        }
        const response = await Axios.post(`/files/upload`, formData, {
            onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
                onProgress(percentCompleted);
            },
        });
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useAddSourceFile = () => {
    const [progress, setProgress] = useState(0);
    const mutation = useMutation<ResponseType, Error, APIPayload>({
        mutationFn: (payload: APIPayload) => addSourceFile(payload, setProgress),
        onSuccess: (data) => {
            toast.success("Source File Added Successfully");
            console.log(data);
        },
        onError: (error) => {
            toast.error("Adding Source File Failed", { description: error.message });
        },
        onSettled: () => {
            setProgress(0);
        },
    });

    return { ...mutation, progress };
};
